<template>
    <section id="resume" class="container-fluid">
        <div class="row">
            <div class="col-md-12">
                <!-- Subsection -->
                <div class="sub-section" v-for="(section, sectionIndex) in subSection" :key="sectionIndex">
                    <!-- Subsection title -->
                    <h2><i class="fas left-align" :class="section.icon"></i>{{section.title}}</h2>

                    <!-- Subsection stories -->
                    <div class="sub-section-details" :class="section.id" v-for="(story, storyIndex) in section.stories" :key="storyIndex">
                        <!-- Story title -->
                        <h3 v-html="story.title"></h3>
                        <!-- Story's settings -->
                        <h4>{{story.institution}}, {{story.from}}&ndash;{{story.until}}</h4>
                        <!-- Story's summary -->
                        <p v-html="story.summary"></p>
                    </div>
                </div>

                <!-- Link to CV -->
                <!-- <a class="btn btn-primary" href="assets/docs/cv-jvsunarja.pdf" target="blank" role="button">
                    View my CV
                </a> -->
            </div>
        </div>
    </section>
</template>

<script>
export default {
    data() {
        return {
            subSection: [
                {
                    title: 'Work Experience',
                    id: 'work',
                    icon: 'fa-briefcase',
                    stories: [
                        {
                            title: 'Junior Developer',
                            institution: 'OnlineFuels',
                            from: 'August 2018',
                            until: 'present',
                            summary: 'Working as a full-stack developer, I am involved in the re-design and development of an online fuel trading platform. I also contributed heavily in the technical switch to a reactive Javascript framework, Vue.js, to help managing and reuse of components across platforms. I also experience Agile working environment on a daily basis with a team of diversing levels of experience.'
                        },
                        {
                            title: 'IT Support',
                            institution: 'The C-ICT Open Learning Centre',
                            from: 'February 2017',
                            until: 'June 2018',
                            summary: 'I set up and managed server-linked computers and printers in a computer-based adult learning centre. Being the only IT support in the centre required me to perform self study on Windows Server 2012 and sometimes hours of trials. I also assisted in teaching practical mathematics, English, and IT as high as Level 2.'
                        },
                        {
                            title: 'Website Manager',
                            institution: 'Indonesian Students Association in Newcastle',
                            from: 'October 2016',
                            until: 'September 2017',
                            summary: 'I was responsible over content and structure management of the association&rsquo;s website. Within my tenure, I made several changes to the then design and structure, which included adding an online shop to ease trading between members. I also designed and created the association&rsquo;s biggest annual event, Discover Indonesia&mdash;the second largest Indonesian cultural event in the UK&mdash;its maiden website.'
                        }
                    ]
                },
                {
                    title: 'Education',
                    id: 'education',
                    icon: 'fa-graduation-cap',
                    stories: [
                        {
                            title: 'Computer Science with Industrial Placement<br />(Human Computer Interaction) <span class="case-sensitive">BSc</span> Honours',
                            institution: 'Newcastle University',
                            from: 'September 2016',
                            until: 'July 2020',
                            summary: 'I graduated with 1st class honours from a sandwich programme, which allowed me to experience a full year working in industry. I achieved this while having to deal with study disruptions throughout my last semester due to the COVID-19 pandemic. Some projects that I have done include producing personas, scenarios, prototypes, websites, and mobile apps.'
                        },
                        {
                            title: 'Cambridge A-Levels',
                            institution: 'SMAK 1 BPK PENABUR Bandung',
                            from: 'July 2013',
                            until: 'June 2016',
                            summary: 'I graduated from one of few schools then in Indonesia acclaimed as eligible to partake Cambridge IGCSE and A Levels. I spent three years studying in both English and Indonesian to graduate with A Levels and a national higher school certificate to my name. During this period, I also participated in various Model United Nations conferences, with an &rsquo;Honourable Mention&rsquo; as an accolade.'
                        }
                    ]
                }
            ]
        }
    }
}
</script>

<style lang="scss" scoped>
section {
    background-color: $colour-grey-light;
    color: $colour-blue-dark;
}

.col-md-12 {
    text-align: center;
}

.sub-section {
    padding: 0 15vw;

    &-details {
        margin: 2rem 0;
        padding: 2rem 5vw;
        text-align: justify;
        border-color: $colour-grey-primary;

        &:nth-child(even).work, &:nth-child(odd).education {
            border-left: 5px groove;
            border-top-left-radius: 30px;
            border-bottom-left-radius: 30px;
            
            &::before {
                padding: 10px;
            }
        }

        &:nth-child(odd).work, &:nth-child(even).education {
            border-right: 3px dotted;
            border-top-right-radius: 30px;
            border-bottom-right-radius: 30px;
            text-align-last: right;
        }

        h3 {
            text-transform: uppercase;
            font-size: 1.3rem;
        }

        h4 {
            font-size: 1rem;
            font-style: italic;
            font-weight: 700;
        }

        p {
            font-size: 0.9rem;
        }

        a {
            color: $colour-blue-light!important;
        }
    }
}

.btn {
    margin-bottom: 2rem;
}
</style>
